module.exports = __webpack_public_path__ + "img/vue1-corpsarr_lavande.6f7ae822.png";